import { Link } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Loader from "../components/loader";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../app/store";
import { fetchStatements } from '../app/slice/txnSlice';

function Transactionhistory() {
    const statementsData = useSelector((state: RootState) => state.statements);
    const [statementList, setStatementList] = useState<any>(statementsData?.statementsData);
    const [filterData, setFilterData] = useState<any>(statementsData?.filterData);
    const [nextPageUrl, setNextPageUrl] = useState<any>(statementsData?.next_page_url);
    const [currentpage, setCurrentPage] = useState<any>(statementsData?.page);
    const [isPageloading, setIsPageLoading] = useState(false);
    const [message, setMessage] = useState("");
    const [txnType, setTxnType] = useState('');
    const dispatch = useDispatch<AppDispatch>();
    const [height] = useState(window.innerHeight);
    const myRef = useRef<HTMLUListElement>(null);

    const handleClickType = (type: string) => {
        setMessage('');
        setTxnType(type);
        setStatementList('')

    };


    useEffect(() => {
        dispatch(fetchStatements({ type: txnType, from: filterData?.from, to: filterData?.to, callBy: 'page' }));

        // eslint-disable-next-line
    }, [dispatch, txnType]);

    useEffect(() => {
        if (statementsData?.call_by === 'date' || statementsData?.call_by === 'page') {
            setStatementList('');
        }

    }, [statementsData?.call_by]);


    useEffect(() => {
        setTimeout(() => {
            if (statementsData?.statementsData.length > 0) {
                setStatementList((prev: any) => [...prev, ...statementsData?.statementsData]);
            } else {
                setStatementList(statementsData?.statementsData)
            }
        }, 10);

    }, [statementsData?.statementsData]);

    
    useEffect(() => {
        setTimeout(() => {
            setStatementList('');
        }, 10);
    }, []);

    useEffect(() => {
        setFilterData(statementsData?.filterData);
    }, [statementsData?.filterData]);

    useEffect(() => {
        setIsPageLoading(statementsData?.isLoading);
    }, [statementsData?.isLoading]);

    useEffect(() => {
        setCurrentPage(statementsData?.page);
        // eslint-disable-next-line
    }, [statementsData?.page]);


    useEffect(() => {
        setNextPageUrl(statementsData?.next_page_url);

    }, [statementsData?.next_page_url]);


    function handleClearDate() {
        setStatementList('');
        dispatch(fetchStatements({ type: txnType, from: '', to: '' }));
    }

    // const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const handleScroll = () => {
        if (myRef.current) {
            const { scrollTop, scrollHeight, clientHeight } = myRef.current;
            if (isPageloading) return;
            if ((scrollTop + clientHeight === scrollHeight) && !isPageloading) {
                if (nextPageUrl) {
                    dispatch(fetchStatements({ type: txnType, from: filterData?.from, to: filterData?.to, page: currentpage + 1 }));
                }
            }
        }
    };


    return (
        <>
            {isPageloading && <Loader />}
            <section className="history">
                <div className="container">
                    <div className="row">
                        <div className="col-12 historyTabs">
                            <ul className="nav nav-pills mb-2" id="pills-tab" role="tablist" >
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link active" id="pills-All-tab" data-bs-toggle="pill" data-bs-target="#pills-All" type="button" role="tab" aria-controls="pills-All" aria-selected="true" onClick={() => handleClickType('')}>All</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-Deposit-tab" data-bs-toggle="pill" data-bs-target="#pills-All" type="button" role="tab" aria-controls="pills-Deposit" aria-selected="false" onClick={() => handleClickType('deposite')}>Deposit</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-Withdrawal-tab" data-bs-toggle="pill" data-bs-target="#pills-All" type="button" role="tab" aria-controls="pills-Withdrawal" aria-selected="false" onClick={() => handleClickType('withdrawal')}>Withdrawal</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-Bonus-tab" data-bs-toggle="pill" data-bs-target="#pills-All" type="button" role="tab" aria-controls="pills-Bonus" aria-selected="false" onClick={() => handleClickType('bonus')}>Bonus</button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button className="nav-link" id="pills-Bet-History-tab" data-bs-toggle="pill" data-bs-target="#pills-All" type="button" role="tab" aria-controls="pills-Bet-History" aria-selected="false" onClick={() => handleClickType('bet')}>Bet History</button>
                                </li>
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div className="tab-pane fade show active" id="pills-All" role="tabpanel" aria-labelledby="pills-All-tab">
                                    {/* <div className="col-12">
                                        <h1>All</h1>
                                    </div> */}
                                    {(filterData?.from !== '' && filterData?.to !== '') &&
                                        <div className="col-12 mb-2">
                                            <div className="filterViwe">
                                                <p>{filterData?.from}<span className="mx-2">-</span>{filterData?.to}</p>
                                                <button type="button" onClick={handleClearDate}>
                                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 10.5858L14.8284 7.75736L16.2426 9.17157L13.4142 12L16.2426 14.8284L14.8284 16.2426L12 13.4142L9.17157 16.2426L7.75736 14.8284L10.5858 12L7.75736 9.17157L9.17157 7.75736L12 10.5858Z" fill="#CCCCCC" />
                                                    </svg>
                                                </button>
                                            </div>
                                        </div>
                                    }
                                    <div className="col-12">
                                        <ul ref={myRef} onScroll={handleScroll} style={{ height: (height - 140) + 'px', overflowY: 'scroll' }}>
                                            {statementList?.length === 0 && !isPageloading && <li className="text-danger text-center mt-5">No record found</li>}
                                            {statementList && (statementList).map((key: any, index: number) => (
                                                <li key={index}>
                                                    <Link to={`/reciept/${key?.id}`} >
                                                        <div className="trxName">
                                                            <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <circle cx="21.5" cy="21.5" r="21.5" fill="#272729" />
                                                                <circle cx="21.5" cy="21.5" r="21.0865" stroke="url(#paint0_linear_1521_7361)" strokeOpacity="0.7" strokeWidth="0.826923" />
                                                                <path d="M28.5389 15.5869H15.3081C14.8695 15.5869 14.4489 15.7611 14.1387 16.0713C13.8285 16.3814 13.6543 16.8021 13.6543 17.2407H13.6965C13.6699 17.3543 13.6558 17.4705 13.6543 17.5872V26.5808C13.6538 26.9222 13.7591 27.2554 13.9556 27.5347C14.152 27.8139 14.4301 28.0255 14.7516 28.1404L24.6747 31.6846C24.9245 31.7738 25.192 31.8017 25.4548 31.7658C25.7176 31.73 25.968 31.6314 26.1847 31.4785C26.4014 31.3256 26.5782 31.1228 26.7001 30.8872C26.822 30.6517 26.8854 30.3902 26.8851 30.125V27.9907H28.5389C28.9775 27.9907 29.3982 27.8165 29.7084 27.5063C30.0185 27.1962 30.1928 26.7755 30.1928 26.3369V17.2407C30.1928 16.8021 30.0185 16.3814 29.7084 16.0713C29.3982 15.7611 28.9775 15.5869 28.5389 15.5869ZM25.2312 30.125L15.3081 26.5808V17.5872L25.2312 21.1314V30.125ZM28.5389 26.3369H26.8851V21.1314C26.8852 20.7902 26.7798 20.4574 26.5833 20.1785C26.3869 19.8996 26.109 19.6883 25.7877 19.5735L19.255 17.2407H28.5389V26.3369Z" fill="white" />
                                                                <path d="M21.0957 24.2696C21.0957 24.4324 21.1278 24.5937 21.1901 24.7442C21.2525 24.8947 21.3438 25.0315 21.459 25.1466C21.5742 25.2618 21.7109 25.3532 21.8614 25.4155C22.0119 25.4779 22.1732 25.5099 22.3361 25.5099C22.499 25.5099 22.6603 25.4779 22.8108 25.4155C22.9613 25.3532 23.098 25.2618 23.2132 25.1466C23.3284 25.0315 23.4197 24.8947 23.4821 24.7442C23.5444 24.5937 23.5765 24.4324 23.5765 24.2696C23.5765 24.1067 23.5444 23.9454 23.4821 23.7949C23.4197 23.6444 23.3284 23.5077 23.2132 23.3925C23.098 23.2773 22.9613 23.1859 22.8108 23.1236C22.6603 23.0613 22.499 23.0292 22.3361 23.0292C22.1732 23.0292 22.0119 23.0613 21.8614 23.1236C21.7109 23.1859 21.5742 23.2773 21.459 23.3925C21.3438 23.5077 21.2525 23.6444 21.1901 23.7949C21.1278 23.9454 21.0957 24.1067 21.0957 24.2696Z" fill="white" />
                                                                <defs>
                                                                    <linearGradient id="paint0_linear_1521_7361" x1="3.30769" y1="-9.50962" x2="57.4712" y2="47.9615" gradientUnits="userSpaceOnUse">
                                                                        <stop stopColor="#DCDCDC" />
                                                                        <stop offset="1" stopOpacity="0.04" />
                                                                    </linearGradient>
                                                                </defs>
                                                            </svg>
                                                            <span className="txnRow">
                                                                <h6>{key?.bet_title}</h6>
                                                                <p>Id : {key?.integrator_transaction_id}</p>
                                                                <p>
                                                                    <span className="hoursAgo">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" width="6" height="7" viewBox="0 0 6 7" fill="none">
                                                                            <circle cx="3" cy="3.25" r="3" fill="url(#paint0_linear_1521_7369)" fillOpacity="0.9" />
                                                                            <defs>
                                                                                <linearGradient id="paint0_linear_1521_7369" x1="0" y1="0.25" x2="6.002" y2="6.24799" gradientUnits="userSpaceOnUse">
                                                                                    <stop stopColor="#03ECD9" />
                                                                                    <stop offset="1" stopColor="#6FB2E9" />
                                                                                </linearGradient>
                                                                            </defs>
                                                                        </svg>
                                                                        {key?.created_at}
                                                                    </span>
                                                                </p>
                                                            </span>
                                                        </div>
                                                        <div className="trxAmount">
                                                            <h5 className={`${key?.txn_type === 'Debit' ? 'faild' : (key?.txn_type === 'Nutral' ? 'pending' : 'success')}`}>{key?.txn_type === 'Debit' ? '- ' : (key?.txn_type === 'Nutral' ? '' : '+')} ₹{key?.base_amount}</h5>
                                                            <p>Bal: ₹{key?.closing_balance}</p>
                                                        </div>
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
export default Transactionhistory